"use client";

import AmpService from "analytics/amplitude/amplitudeEvents";
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import { RootState } from "interfaces/generics.type";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { memo } from "react";
import { useSelector } from "react-redux";
import { isLoginPage } from "util/url/checkRouteInclude";
import useScreenSize from "../../hoc/useScreenSize";
import HeaderMobile from "./HeaderMobile";
import MobileHeader from "./MobileHeader";
import styles from "./headerWrapper.module.scss";
import HeaderCarousel from "./HeaderCarousel";
const HeaderDesktop = dynamic(() => import(/* webpackChunkName: "header-desktop" */ "./HeaderDesktop"),
  { loading: () => <LoaderSkeleton height={90} /> });

function HeaderWrapper(props: any) {
  const [isMobile] = useScreenSize();
  const userCart = useSelector((state: RootState) => state.shoppingCart);
  const { averageRating, totalReviewCount } = useSelector((store: RootState) => store.authenticationState);
  // const [, infoData] = useApiDataLoadOnce(getSitejabberBusinessInfoApi);
  const infoData = { overallRating: averageRating, totalReviews: totalReviewCount };

  const { openSlideMenu, onClickLogin } = props;
  const router = useRouter();

  let headerContent;
  // snst mobileHeaderRef = useRef();

  function handleShoppingCartClick() {
    AmpService.clickShoppingCart(userCart);
  }

  // function changeCss () {
  //   const el = mobileHeaderRef.current;
  //   console.log("mainRef",mainRef.current);

  //   if(isInViewport(el, 0)){
  //     stickyHeaderRef.current.style.position = "sticky";
  //    stickyHeaderRef.current.style.width = "100%";
  //   }else {
  //    stickyHeaderRef.current.style.position = "fixed";
  //    stickyHeaderRef.current.style.width = "100%";
  //   }
  // }
  // useEffect(() => {
  //   window.addEventListener("scroll", changeCss , false);
  // }, [])

  if (!isMobile) {
    headerContent = (
      <header className="hidden-print" style={{ backgroundColor: isLoginPage(router.pathname) ? "#fff" : "#1a4d7c" }}>
        <HeaderDesktop
          {...props}
          handleShoppingCartClick={handleShoppingCartClick}
          infoData={infoData}
        />
      </header>
    );
  } else {
    headerContent = (
      <>
        <HeaderCarousel infoData={infoData} />
        <div className={styles.mobile_container}>
          <MobileHeader
            handleShoppingCartClick={handleShoppingCartClick}
            infoData={infoData}
            {...props}
            {...{ openSlideMenu, onClickLogin }}
          />
          <HeaderMobile
            {...props}
            handleShoppingCartClick={handleShoppingCartClick}
            infoData={infoData}
          />
        </div>

      </>

    );
  }

  return headerContent;
}

export default memo(HeaderWrapper);
